import { UserGuideButton } from '@/components/guide/UserGuideButton';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FunctionComponent } from 'react';

interface StockUserGuideButtonProps {}

const StockUserGuideButton: FunctionComponent<StockUserGuideButtonProps> = () => {
  const routePrefix = useCustomerRoutePrefix();

  return <UserGuideButton newRoute={`${routePrefix}/advanced/stockGuide`} />;
};

export default StockUserGuideButton;
